import { render } from "./profile-button.vue?vue&type=template&id=e838a20c"
import script from "./profile-button.vue?vue&type=script&lang=js"
export * from "./profile-button.vue?vue&type=script&lang=js"
script.render = render

export default script